import { useEffect, useState } from "react";
import logoimage from "../assets/VardhamanLogo4.jpg";
import { useLocation, useNavigate } from "react-router-dom";
import {
  // FaFacebookF,
  // FaInstagram,
  // FaWhatsapp,
  FaPhoneSquareAlt,
  // FaLinkedin,
} from "react-icons/fa";
import { MdEmail, MdKeyboardArrowRight } from "react-icons/md";
import { MdKeyboardArrowDown } from "react-icons/md";
import { motion, AnimatePresence } from "framer-motion";
import { RxHamburgerMenu } from "react-icons/rx";
import { IoClose } from "react-icons/io5";
// import MarqueeSection from "../components/MarqueeSection";
// import { InquiryContext } from "../App";
// import UserEnquiryModel from "./UserEnquiryModel";
// import { useSelector } from "react-redux";

const Navbar = () => {
  // const { openInquiryModel, setOpenInquiryModel } = useContext(InquiryContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(null);
  const [activeSubTab, setActiveSubTab] = useState(null);
  const [view, setView] = useState(false);
  const [, setVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  // const { allDocuments } = useSelector(state => state.documents);
  // const { allMarquees } = useSelector(state => state.marquees)
  // const { collegesWithCourses } = useSelector(state => state.courses)

  useEffect(() => {
    const handleScroll = () => {
      if (view) return;
      if (window.scrollY > lastScrollY) {
        setVisible(false);
      } else {
        setVisible(true);
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view]);
  const [currentTab, setCurrentTab] = useState("home")
  const tabs = [
    {
      id: 1,
      name: "Home",
      path: "/",
    },
    {
      id: 2,
      name: "About",
      path: "/about",
    }, {
      id: 3,
      name: "Trustees",
      path: "/trustees",
    },
    {
      id: 4,
      name: "Academics",
      path: "/Academics"
      // hasSubMenu: false,
      // subTabTypes: [
      //   { id: 1, name: "G.T.U" },
      //   { id: 2, name: "G.U" },
      // ],
      // subTabs: collegesWithCourses?.map((college) => ({
      //   college_id: college?.id,
      //   category: college?.college_name,
      //   college_type: college?.college_type,
      //   items: college?.courses?.map((course) => ({
      //     id: course?.id,
      //     name: course?.course_name,
      //     path: `/academics/${college?.id}/${course?.course_name}/${course?.id}`,
      //     images: course.images,
      //   })),
      // })),
    },
    {
      id: 5,
      name: "Contact",
      path: "/Contact"
    }
    // { id: 4, name: "Activities", path: "/activities" },
    // {
    //   id: 5,
    //   name: "Student Section",
    //   path: "/studentsection",
    //   hasSubMenu: true,
    //   subTabs: [
    //     {
    //       items: [
    //         {
    //           id: 1,
    //           name: "Student Achievements",
    //           path: `/StudentAchievements`,
    //         },
    //         {
    //           id: 2,
    //           name: "Student Testimonials",
    //           path: `/StudentTestimonials`,
    //         },
    //         {
    //           id: 3,
    //           name: "Student Clubs",
    //           path: `/StudentClubs`,
    //         },
    //         {
    //           id: 4,
    //           name: "Alumni Association",
    //           path: `/OurAlumni`,
    //         },
    //         ...(allDocuments?.map((document) => ({
    //           college_id: document?.college_id,
    //           course_id: document?.course_id,
    //           college_name: document?.college_name,
    //           course_name: document?.course_name,
    //           name: document?.name,
    //           document_id: document?.id,
    //           type: "document",
    //           path: `/Documents/${document?.name?.replace("/", "-")}/${document?.id
    //             }`,
    //         })) || []),
    //       ],
    //     },
    //   ],
    // },
    // { id: 6, name: "News", path: "/news" },
    // { id: 7, name: "Contact", path: "/contact" },
    // { id: 9, name: "Jobs", path: "/Jobs" },
    // { id: 8, name: "Enquiry Now" },
  ];
  // const handleTabChange = (tab) => {
  //   // navigate(tab?.path);
  //   window.scrollTo(`${tab?.name}`)
  //   setIsSubMenuOpen(false);
  //   setView(!view);
  // };
  const handleTabChange = (tab) => {
    const sectionId = tab.name.toLowerCase();
    const offset = 100; // adjust this value as needed (e.g. height of navbar)

    if (window.location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        const y = element.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    } else {
      navigate('/', { state: { scrollTo: sectionId } });
    }
    setCurrentTab(sectionId)
    setIsSubMenuOpen(false);
    setView(!view);
  };

  return (
    <div
      className={`sticky top-0 z-50 transition-all duration-300 bg-[#FAF8F7] shadow-md`}
    >
      <div className="flex items-center relative justify-between">
        <div className="md:w-1/5 lg:w-1/4 w-1/2 flex items-center justify-center p-1">
          <img
            src={logoimage}
            alt="Logo"
            className="w-auto h-16 object-scale-down cursor-pointer"
            onClick={() => handleTabChange(tabs[0])}
          />
          {/* <div className="p-4">
            <h1>Vardhman Charitable Trust</h1>
          </div> */}
        </div>
        <div className="md:hidden flex p-4">
          <button
            onClick={() => {
              setView(!view);
            }}
            className="flex items-end justify-end transition-all duration-300"
          >
            {view ? (
              <IoClose size={24} className="text-primary" />
            ) : (
              <RxHamburgerMenu size={24} className="text-primary" />
            )}{" "}
          </button>
        </div>
        <div className="flex-col items-center justify-center w-full md:flex hidden">
          <nav className="flex items-center justify-end w-full ">
            <ul
              className={` flex items-center justify-around px-10 xl:w-3/5 lg:w-3/5 w-full`}
            >
              {tabs.map((tab) => (
                <li
                  key={tab.id}
                  className="relative group"
                  onMouseEnter={() => {
                    if (window.innerWidth > 1024 && tab.hasSubMenu) {
                      setIsSubMenuOpen({ tabId: tab.id });
                    }
                  }}
                  onMouseLeave={() => {
                    if (window.innerWidth > 1024 && tab.hasSubMenu) {
                      setIsSubMenuOpen(null);
                    }
                  }}

                  onClick={() => {
                    if (window.innerWidth < 1280) {
                      setIsSubMenuOpen((prev) =>
                        prev?.tabId === tab.id ? null : { tabId: tab.id }
                      );
                    }
                  }}
                >
                  {" "}
                  {tab.name === "Enquiry Now" ? (
                    <div
                      onClick={(e) => {
                        // setOpenInquiryModel(true);
                        window.open("https://admissions.lokmanyamis.com/")
                      }} className="bg-primary text-white hover:bg-secondary px-4 py-2 rounded-xl cursor-pointer transition-all text-sm">
                      <p>
                        {tab.name}
                      </p>
                    </div>
                  ) : (
                    <p
                      onClick={(e) => {
                        if (
                          !["Student Section"].includes(tab.name)
                        ) {
                          handleTabChange(tab);
                        }
                      }}
                      className={`flex items-center ${currentTab === tab?.name?.toLowerCase()
                        // ||
                        // (tab?.name === "Academics" &&
                        //   location?.pathname.startsWith("/academics")) ||
                        // (tab?.name === "Student Section" &&
                        //   [
                        //     "/StudentAchievements",
                        //     "/StudentTestimonials",
                        //   ].includes(location?.pathname))
                        ? `text-secondary font-semibold`
                        : `text-primary`
                        } cursor-pointer lg:text-base text-sm px-2 py-2 group relative hover:scale-105 capitalize`}
                    >
                      <span>{tab.name}</span>
                      {tab.hasSubMenu && (
                        <MdKeyboardArrowDown
                          size={20}
                          className="lg:ml-1 transition-transform group-hover:rotate-180"
                        />
                      )}
                    </p>
                  )}
                  {/* Dropdown Menu for "Academics" */}
                  {isSubMenuOpen?.tabId === tab.id && (
                    <div
                      onClick={(e) => e.stopPropagation()}
                      className={`absolute top-full left-0 bg-white text-primary ${tab?.name === "Academics" ? `w-48` : `w-96`
                        } shadow-lg z-50`}
                    >
                      {tab?.subTabTypes?.map((subTabType) => (
                        <div
                          key={subTabType.id}
                          className="relative group"
                          onMouseEnter={() => {
                            if (window.innerWidth > 1024) {
                              setActiveSubTab(subTabType?.name);
                            }
                          }}
                          onMouseLeave={() => {
                            if (window.innerWidth > 1024) {
                              setActiveSubTab(null);
                            }
                          }}
                          onClick={() => {
                            if (window.innerWidth < 1280) {
                              setActiveSubTab((prev) =>
                                prev === subTabType?.name ? null : subTabType?.name
                              );
                            }
                          }}
                        >

                          <div className="overflow-hidden">
                            <div
                              className={`px-4 py-2 flex items-center justify-between cursor-pointer hover:scale-105 hover:bg-primary ${activeSubTab === subTabType?.name &&
                                `bg-primary text-white`
                                } hover:text-white capitalize`}
                            >
                              {subTabType?.name}
                              <MdKeyboardArrowRight size={18} />
                            </div>
                          </div>
                          {/* Nested Submenu */}
                          {activeSubTab === subTabType?.name && (
                            <div className="absolute left-full top-0 bg-white text-primary w-96 shadow-lg h-[90vh] pb-40 scrollbar-hide overflow-y-auto">
                              {tab?.subTabs
                                .filter(
                                  (college) =>
                                    college.college_type ===
                                    (subTabType?.name).replaceAll(".", "")
                                )
                                .map((college, index) => (
                                  <div key={college.college_id} className="p-2">
                                    <div key={index} className="p-1">
                                      <h2
                                        className={`text-base font-semibold  ${college?.category ? `border-b` : ``
                                          } mb-1 capitalize`}
                                      >
                                        {college?.category}
                                      </h2>
                                      <ul className="">
                                        {college?.items?.map((subTab) => (
                                          <li
                                            key={subTab.id}
                                            onClick={() =>
                                              handleTabChange(subTab)
                                            }
                                            className={`px-3 mb-1 pt-1 py-2 text-sm rounded-lg cursor-pointer transition-all ${decodeURIComponent(
                                              location?.pathname
                                            ) ===
                                              decodeURIComponent(subTab.path)
                                              ? `bg-primary text-white`
                                              : `text-primary hover:bg-primary hover:text-white`
                                              }`}
                                          >
                                            {subTab?.name}
                                          </li>
                                        ))}
                                      </ul>
                                    </div>
                                  </div>
                                ))}
                            </div>
                          )}
                        </div>
                      ))}
                      {!(tab?.subTabTypes?.length > 0) &&
                        tab?.subTabs &&
                        tab?.subTabs?.map((college, index) => (
                          <div key={college?.college_id} className="p-2">
                            <div key={index} className={`p-1`}>
                              <ul className="border-b-2 space-y-2">
                                {college?.items
                                  ?.filter((data) => data?.type !== "document")
                                  ?.map((subTab) => (
                                    <li
                                      key={subTab.id}
                                      onClick={() => handleTabChange(subTab)}
                                      className={`px-3 pt-1 py-2 text-sm rounded-lg cursor-pointer transition-all ${decodeURIComponent(
                                        location?.pathname
                                      ) === decodeURIComponent(subTab.path)
                                        ? `bg-primary text-white`
                                        : `text-primary hover:bg-primary hover:text-white`
                                        }`}
                                    >
                                      {subTab?.name}
                                    </li>
                                  ))}

                              </ul>
                              <ul className="grid grid-cols-2 gap-2">
                                {Array.from(
                                  new Map(
                                    college?.items
                                      ?.filter((data) => data?.type === "document")
                                      .map((item) => [item.name, item])
                                  ).values()
                                )?.map((subTab) => (
                                  <li
                                    key={subTab.id}
                                    onClick={() => handleTabChange(subTab)}
                                    className={`px-3 pt-1 py-2 text-sm rounded-lg cursor-pointer transition-all ${decodeURIComponent(
                                      location?.pathname
                                    ) === decodeURIComponent(subTab.path)
                                      ? `bg-primary text-white`
                                      : `text-primary hover:bg-primary hover:text-white`
                                      }`}
                                  >
                                    {subTab?.name}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        ))}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </nav>
        </div>
        {/* mobile view */}
        {view && (
          <div className="fixed inset-0 top-[75px] flex-col w-full md:hidden flex z-50 overflow-auto">
            <motion.div
              className="w-full h-full"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.4 }}
              exit={{ opacity: 0, x: 50 }}
            >
              <nav className="flex items-center justify-between w-full p-2 bg-gradient-to-b to-white from-[#FAFAFA] z-50 text-primary border-t-4">
                <ul className="flex flex-col items-end w-full justify-end space-y-2">
                  <div className="flex flex-col items-end space-x-4">
                    <li className="flex items-center space-x-2">
                      <FaPhoneSquareAlt size={20} />
                      <span>072030 61010</span>
                    </li>
                    <li className="flex items-center space-x-2">
                      <MdEmail size={20} />
                      <span>lokmanyaptc@gmail.com</span>
                    </li>
                  </div>
                  {/* <div className="flex items-center sm:gap-2 gap-2 justify-center sm:justify-start flex-wrap">
                    <Link
                      to={
                        "https://www.facebook.com/share/18ZKsu3fZR/"
                      }
                      target="_blank"
                      className="bg-white rounded-full shadow-xl p-2"
                    >
                      <FaFacebookF
                        size={24}
                        className="hover:text-secondary text-primary transition-colors duration-200"
                      />
                    </Link>
                    <Link
                      to={"https://www.instagram.com/lokmanyacollegeofficial/"}
                      target="_blank"
                      className="bg-white rounded-full shadow-xl p-2"
                    >
                      <FaInstagram
                        size={24}
                        className="hover:text-secondary text-primary transition-colors duration-200"
                      />
                    </Link>
                    <Link
                      to={"https://wa.me/+917203061010"}
                      target="_blank"
                      className="bg-white rounded-full shadow-xl p-2"
                    >
                      <FaWhatsapp
                        size={24}
                        className="hover:text-secondary text-primary transition-colors duration-200"
                      />
                    </Link>
                    <Link
                      to={"https://www.linkedin.com/company/106963878/admin/?lipi=urn%3Ali%3Apage%3Ad_flagsh"}
                      target="_blank"
                      className="bg-white rounded-full shadow-xl p-2"
                    >
                      <FaLinkedin
                        size={24}
                        className="hover:text-secondary text-primary transition-colors duration-200"
                      />
                    </Link>
                    <Link
                      to={"tel:+917203061010"}
                      target="_blank"
                      className="bg-white rounded-full shadow-xl p-2"
                    >
                      <FaPhoneSquareAlt
                        size={24}
                        className="hover:text-secondary text-primary transition-colors duration-200"
                      />
                    </Link>
                    <Link
                      to={"mailto:mailto:lokmanyaatpc@gmail.com"}
                      target="_blank"
                      className="bg-white rounded-full shadow-xl p-2"
                    >
                      <MdEmail
                        size={24}
                        className="hover:text-secondary text-primary transition-colors duration-200"
                      />
                    </Link>

                  </div> */}
                </ul>
              </nav>
              <nav className="relative w-full bg-gradient-to-t to-white from-[#FAF8F7] h-full overflow-auto z-50">
                <ul className="">
                  {tabs.map((tab) => (
                    <li
                      key={tab.id}
                      className="relative group p-2"
                      onClick={() => {
                        if (
                          tab?.hasSubMenu &&
                          isSubMenuOpen?.tabId === tab?.id
                        ) {
                          setIsSubMenuOpen(null);
                        } else
                          tab.hasSubMenu && setIsSubMenuOpen({ tabId: tab.id });
                      }}
                    >
                      {/* Inquiry Now Button */}
                      {tab.name === "Enquiry Now" ? (
                        <div onClick={(e) => {
                          // setOpenInquiryModel(true);
                          window.open("https://admissions.lokmanyamis.com/")
                        }} className=" text-primary hover:bg-primary hover:text-white px-2 py-2 rounded-xl cursor-pointer transition-all text-sm capitalize">
                          <p >
                            {tab.name}
                          </p>
                        </div>
                      ) : (
                        <p
                          onClick={() => {
                            if (
                              !["Student Section"].includes(
                                tab.name
                              )
                            ) {
                              handleTabChange(tab);
                            }
                          }}
                          className={`flex items-center ${currentTab === tab?.name.toLowerCase()
                            // ||
                            // (tab?.name === "Academics" &&
                            //   location?.pathname.startsWith("/academics")) ||
                            // (tab?.name === "Student Section" &&
                            //   [
                            //     "/StudentAchievements",
                            //     "/StudentTestimonials",
                            //   ].includes(location?.pathname))
                            ? `text-secondary font-semibold`
                            : `text-primary`
                            } cursor-pointer lg:text-base text-sm px-2 py-2 group relative`}
                        >
                          <span className="capitalize">{tab.name}</span>
                          {tab?.hasSubMenu && (
                            <MdKeyboardArrowDown
                              size={20}
                              className={`ml-1 transition-transform ${tab?.hasSubMenu &&
                                isSubMenuOpen?.tabId &&
                                isSubMenuOpen?.tabId === tab?.id
                                ? `rotate-180`
                                : null
                                }`}
                            />
                          )}
                        </p>
                      )}
                      <AnimatePresence>
                        {isSubMenuOpen?.tabId === tab.id && tab.hasSubMenu && (
                          <motion.div
                            className="w-full bg-gray-100"
                            initial={{ opacity: 0, height: 0 }}
                            animate={{ opacity: 1, height: "auto" }}
                            exit={{ opacity: 0, height: 0 }}
                            onClick={(e) => {
                              e?.stopPropagation();
                            }}
                          >
                            {tab?.subTabTypes?.map((subTabType) => (
                              <div key={subTabType.id} className="px-4">
                                <div
                                  className="flex justify-between items-center py-2 text-primary cursor-pointer capitalize"
                                  onClick={() => {
                                    if (activeSubTab === subTabType?.name) {
                                      setActiveSubTab(null);
                                    } else setActiveSubTab(subTabType?.name);
                                  }}
                                >
                                  {subTabType?.name}
                                  <MdKeyboardArrowRight
                                    size={18}
                                    className={`transition-transform ${activeSubTab === subTabType.name
                                      ? "rotate-90"
                                      : ""
                                      }`}
                                  />
                                </div>

                                {/* Nested Submenu */}
                                <AnimatePresence>
                                  {activeSubTab === subTabType.name && (
                                    <motion.ul
                                      className="pl-4 pb-2"
                                      initial={{ opacity: 0, height: 0 }}
                                      animate={{ opacity: 1, height: "auto" }}
                                      exit={{ opacity: 0, height: 0 }}
                                    >
                                      {tab?.subTabs
                                        .filter(
                                          (college) =>
                                            college.college_type ===
                                            subTabType?.name.replaceAll(".", "")
                                        )
                                        .map((college) => (
                                          <li
                                            key={college.college_id}
                                            className="py-1"
                                          >
                                            <h2
                                              className={`text-base text-primary font-semibold capitalize  ${college?.category
                                                ? `border-b`
                                                : ``
                                                } mb-1`}
                                            >
                                              {college?.category}
                                            </h2>
                                            <ul>
                                              {college?.items?.map((subTab) => (
                                                <li
                                                  key={subTab.id}
                                                  onClick={() =>
                                                    handleTabChange(subTab)
                                                  }
                                                  className={`px-3 mb-1 pt-1 py-2 text-sm rounded-lg cursor-pointer transition-all capitalize ${decodeURIComponent(
                                                    location?.pathname
                                                  ) ===
                                                    decodeURIComponent(
                                                      subTab.path
                                                    )
                                                    ? `bg-primary text-white`
                                                    : `text-primary hover:bg-primary hover:text-white`
                                                    }`}
                                                >
                                                  {subTab?.name}
                                                </li>
                                              ))}
                                            </ul>
                                          </li>
                                        ))}
                                    </motion.ul>
                                  )}
                                </AnimatePresence>
                              </div>
                            ))}
                            {!(tab?.subTabTypes?.length > 0) &&
                              tab?.subTabs &&
                              tab?.subTabs?.map((college, index) => (
                                <div key={college?.college_id} className="p-2">
                                  <div key={index} className={`p-1`}>
                                    <ul className="border-b-2 space-y-2">
                                      {college?.items
                                        ?.filter(
                                          (data) => data?.type !== "document"
                                        )
                                        ?.map((subTab) => (
                                          <li
                                            key={subTab.id}
                                            onClick={() =>
                                              handleTabChange(subTab)
                                            }
                                            className={`px-3 pt-1 py-2 text-sm rounded-lg cursor-pointer transition-all ${decodeURIComponent(
                                              location?.pathname
                                            ) ===
                                              decodeURIComponent(subTab.path)
                                              ? `bg-primary text-white`
                                              : `text-primary hover:bg-primary hover:text-white`
                                              }`}
                                          >
                                            {subTab?.name}
                                          </li>
                                        ))}
                                    </ul>
                                    <ul className="grid grid-cols-2 gap-2">
                                      {Array.from(
                                        new Map(
                                          college?.items
                                            ?.filter((data) => data?.type === "document")
                                            .map((item) => [item.name, item])
                                        ).values()
                                      )?.map((subTab) => (
                                        <li
                                          key={subTab.id}
                                          onClick={() =>
                                            handleTabChange(subTab)
                                          }
                                          className={`px-3 pt-1 py-2 text-sm rounded-lg cursor-pointer transition-all ${decodeURIComponent(
                                            location?.pathname
                                          ) ===
                                            decodeURIComponent(subTab.path)
                                            ? `bg-primary text-white`
                                            : `text-primary hover:bg-primary hover:text-white`
                                            }`}
                                        >
                                          {subTab?.name}
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                </div>
                              ))}
                          </motion.div>
                        )}
                      </AnimatePresence>

                      {/* Submenu for Academics */}
                      {/* {tab.hasSubMenu && isSubMenuOpen && (
                        <div className="w-full transform transition-transform overflow-auto">
                          <AnimatePresence>
                            <motion.div
                              className="w-full"
                              initial={{ opacity: 0, y: -10 }}
                              animate={{ opacity: 1, y: 0 }}
                              transition={{
                                duration: 0.5,
                              }}
                              exit={{
                                opacity: 0,
                                y: -50,
                              }}
                            >
                              <div className="bg-[#223657] border-t-2 border-primary w-full p-8">
                                <h1 className="text-xl font-bold text-[#ffffff] mb-2">
                                  List of Programmes
                                </h1>
                                <div className="grid grid-cols-1">
                                  {tab?.subTabs?.map((category, index) => (
                                    <div key={index} className="h-fit">
                                      <h2 className="text-lg font-semibold text-[#ffffff] border-b-2 border-dashed pb-2">
                                        {category.category}
                                      </h2>
                                      <ul className="p-1">
                                        {category.items.map((subTab) => (
                                          <li
                                            key={subTab.id}
                                            onClick={() =>
                                              handleTabChange(subTab)
                                            }
                                            className={`${
                                              decodeURIComponent(
                                                location?.pathname
                                              ) ===
                                              decodeURIComponent(subTab.path)
                                                ? `bg-white text-primary`
                                                : `text-white hover:bg-[#ffffff] hover:text-primary`
                                            }  px-3 py-2 w-fit rounded-lg   cursor-pointer transition-all`}
                                          >
                                            {subTab.name}
                                          </li>
                                        ))}
                                      </ul>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </motion.div>
                          </AnimatePresence>
                        </div>
                      )} */}
                    </li>
                  ))}
                </ul>
              </nav>
            </motion.div>
          </div>
        )}
      </div>
      {/* {openInquiryModel && (
        <UserEnquiryModel onClose={() => setOpenInquiryModel(false)} />
      )} */}
    </div>
  );
};

export default Navbar;
